import React from 'react';

import DatasetColumnLabel from 'components/DatasetColumnLabel';

const NumericalOption = () => (
  <DatasetColumnLabel type="numerical">
    <span>Numerical</span>
  </DatasetColumnLabel>
);

export default NumericalOption;
